import React from "react";
import PropTypes from "prop-types";
import { activeToMaxPercentageRatio } from "../../utils";
import styles from "./styles.module.scss";
import { NOTIFICATION_COLORS } from "../../constants"

const RemainingCapacity = React.memo(({ practiceTeamParticipant, ...props }) => {
  const { providerPanelExtension } = practiceTeamParticipant || {};
  if (!providerPanelExtension) {
    return null;
  }

  const { activeSize, maxSize, openSize } = providerPanelExtension;
  const { decimalPercent } = activeToMaxPercentageRatio(activeSize, maxSize);
  const color = NOTIFICATION_COLORS[decimalPercent] || null;

  return (
    <div
      {...props}
      className={styles.remainingCapacity}
      style={{ color }}
    >
      {openSize}
    </div>
  );
});

RemainingCapacity.propTypes = {
  practiceTeamParticipant: PropTypes.object.isRequired,
};

RemainingCapacity.displayName = "RemainingCapacity";

export default RemainingCapacity;
